import httpRequest from "../../services/httpreq";

export function getMfrs() {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "getMfrs",
      body: {
        page: 1,
        pagelength: 50
      },
      token: window.token
    };

    httpRequest(opt, (response) => {
      if (response && response.message === "OK" && response.obj && response.obj.manufacturers) {
        resolve(response.obj.manufacturers);
      } else {
        reject(response.message);
      }
    });
  });
}

export function addMfr(mfname, phone, address) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "addMfr",
      body: {
        mfname,
        phone,
        address
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK" && response.obj && response.obj.manufacturer) {
        resolve(response.obj.manufacturer);
      } else {
        reject(response.message);
      }
    });
  });
}

export function delMfr(_id) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "delMfr",
      body: {
        _id
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK") {
        resolve();
      } else {
        reject(response.message);
      }
    });
  });
}

export function updateMfr(_id, mfname, phone, address) {
  return new Promise((resolve, reject) => {
    let opt = {
      cmd: "updateMfr",
      body: {
        _id,
        mfname,
        phone,
        address
      },
      token: window.token
    };
    httpRequest(opt, (response) => {
      if (response && response.message === "OK") {
        resolve();
      } else {
        reject(response.message);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/topography/js/RGP-Mfr.js